module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/81d5d1258558641e78d425193753207c.svg";